import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from 'react-router-dom';
import Board from "./Board/Board";
import { getScoutGroupList, getGeoRegionList, setScoutActiveTab } from "../../actions/scout-kanban";
import { getFarmUsersList } from "../../actions/scout-kanban";
import "../../../assets/scss/crewkanban.scss";
import { usePermission } from "../../helpers/common";

const ScoutKanban = () => {
    const { farmId } = useParams();
    const dispatch = useDispatch();
    const allow = usePermission();
    const range = useSelector((state) => state.analyze.searchParams.custom);

    const defaultScoutTab = allow("field-grouping", "view") ? "scout" : "observation";

    useEffect(() => {
        dispatch(getScoutGroupList({ farmId }));
        dispatch(getGeoRegionList(farmId, true, range))
        dispatch(getFarmUsersList(farmId));
    }, [farmId])
    useEffect(() => {
        dispatch(setScoutActiveTab(defaultScoutTab));
    }, []);
    return (
        <Board />
    );
}

export default ScoutKanban;